"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LocalDatastoreController = _interopRequireDefault(require("./LocalDatastoreController.react-native"));
var _LocalDatastoreController2 = _interopRequireDefault(require("./LocalDatastoreController.default"));
let LocalDatastoreController = _LocalDatastoreController2.default;
var _default = exports.default = LocalDatastoreController;